/* import __COLOCATED_TEMPLATE__ from './azure-blob-config-bucket.hbs'; */
/* RESPONSIBLE TEAM: team-data-foundations */
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';

import type IntlService from 'ember-intl/services/intl';
import type NotificationsService from 'embercom/services/notifications-service';

interface Signature {
  Args: {
    exportDefinitionPersisted: boolean;
    bucketName: string;
    maxBucketNameLength: number;
    azureStorageAccountName: string;
    azureTenantId: string;
    resetBucketVerification: () => void;
    updateAzureStorageAccountName: (value: string) => void;
    updateAzureTenantId: (value: string) => void;
    updateBucketName: (value: string) => void;
  };
  Blocks: {
    default: [];
  };
  Element: null;
}

export default class AzureBlobConfigBucket extends Component<Signature> {
  @service declare notificationsService: InstanceType<typeof NotificationsService>;
  @service declare intl: IntlService;

  get clientId() {
    return '1e94f434-e318-42c8-a272-99e3eb080410';
  }

  async copyValue(value: string) {
    await navigator.clipboard.writeText(value);
    this.notificationsService.notifyConfirmation(
      this.intl.t('settings.bulk-export.azure-blob-config.value-copied'),
    );
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Settings::BulkExport::ConfigurationDataExport::AzureBlobConfigBucket': typeof AzureBlobConfigBucket;
    'settings/bulk-export/configuration-data-export/azure-blob-config-bucket': typeof AzureBlobConfigBucket;
  }
}
